import {Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [],
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.css'
})
export class AboutUsComponent  extends TemplateComponent   implements  OnInit {
  imageUrl: string = "assets/images/aboutUs.png";
  ngOnInit() {
    this.titleService.setTitle($localize`:@@About us:About us`)
  }

}
